let language = {
    "A116P005": 'Thank you for your message, we will contact you with your phone or email a little bit later.'
};

export { language }